import { getGlobalVal } from "../utilities/utils";
import { CACHE_CONSTANTS } from "./cacheConstants";
const BUILD_VERSION = process.env.BUILD_VERSION;
const MINIFICATION_ENABLED = process.env.MINIFICATION_ENABLED;
export const WC_NAME_PREFIX = 'ez-';
export const SHADOW_DOM_ENABLED = true;
export const ACCESS_TOKEN_KEY = CACHE_CONSTANTS.CACHE_KEYS.ACCESS_TOKEN;
export const CUSTOMER_NAME_CONFIG_TIMEOUT_MS = 30000;
export const ZIP_CODE_REGEX = /^[0-9]{5}$/;
export const RC_WC_Map = {
    EZQuote: {
        name: `${WC_NAME_PREFIX}quote`
    }
};
export const Domain = (() => {
    var _a;
    let baseUrl = `/`;
    try {
        const tmpSrc = (_a = document === null || document === void 0 ? void 0 : document.currentScript) === null || _a === void 0 ? void 0 : _a.getAttribute('src');
        if (tmpSrc && tmpSrc.includes('http://') || (tmpSrc === null || tmpSrc === void 0 ? void 0 : tmpSrc.includes('https://'))) {
            baseUrl = `${new URL(tmpSrc).origin}`;
        }
    }
    catch (error) {
        console.error(error);
    }
    return baseUrl;
})();
export const getWCScriptURL = (wcName) => {
    return `${Domain}/web-components/js/${wcName}.wc.${BUILD_VERSION}.${MINIFICATION_ENABLED ? 'min.js' : '.js'}`;
};
export const getWCStyleURL = (wcName) => {
    return `${Domain}/web-components/css/${wcName}.wc.${BUILD_VERSION}.${MINIFICATION_ENABLED ? 'min.css' : '.css'}`;
};
export const EZ_GLOBAL_CSS_ID = `ez_globals_css`;
export const EZ_GLOBAL_CSS_SRC = `${Domain}/ez-globals.${BUILD_VERSION}.${MINIFICATION_ENABLED ? 'min.css' : '.css'}`;
export const EZ_ENV_SCRIPT_ID = `ez_env_vars_js`;
export const EZ_ENV_SCRIPT_SRC = `${Domain}/api/ez-env-vars.min.js?v=${BUILD_VERSION}`;
export const EZ_VENDORS_SCRIPT_ID = `ez_vendors_js`;
export const EZ_VENDORS_SCRIPT_SRC = `${Domain}/web-components/ez-vendors.${BUILD_VERSION}.${MINIFICATION_ENABLED ? 'min.js' : '.js'}`;
export const EZ_GOOGLE_RECAPTCHA_ID = `ez_google_recaptcha_js`;
export const EZ_RECAPTCHA_SCRIPT_SRC = `https://www.google.com/recaptcha/api.js?render=${getGlobalVal('RECAPTCHA_SITE_KEY')}`;
